var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounselor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.11 139.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}.cls-4{stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.11,70a69.56,69.56,0,1,0-69.57,69.58A69.56,69.56,0,0,0,139.11,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.54,128.76A69.56,69.56,0,0,1,.19,64.36C.07,66.07,0,67.8,0,69.54a69.56,69.56,0,1,0,139.11,0c0-1.74-.06-3.47-.19-5.18A69.59,69.59,0,0,1,69.54,128.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.54,10.35a69.58,69.58,0,0,1,69.38,64.37c.13-1.71.19-3.44.19-5.18A69.56,69.56,0,0,0,0,69.54c0,1.74.07,3.47.19,5.18A69.55,69.55,0,0,1,69.54,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.45,62.3c0-17.65-17.9-32-39.89-32s-39.9,14.36-39.9,32,17.9,32,39.9,32c.74,0,1.52,0,2.36-.06l24.45,14.63.1,0a3.48,3.48,0,0,0,.48.21l.18,0a2.59,2.59,0,0,0,.63.08h0a3.29,3.29,0,0,0,.63-.08l.17-.06A2.26,2.26,0,0,0,96,109l.17-.09a2.1,2.1,0,0,0,.41-.31l.1-.08a2.55,2.55,0,0,0,.41-.51l0,0s0-.11.08-.16a2.21,2.21,0,0,0,.12-.27,1.12,1.12,0,0,0,.08-.26,1,1,0,0,0,.06-.25c0-.1,0-.2,0-.3s0-.12,0-.17v-24C103.29,76.79,106.45,69.67,106.45,62.3Zm-37,26.42c-1.05.06-2,.1-2.87.1-19,0-34.4-11.9-34.4-26.52s15.43-26.51,34.4-26.51S101,47.69,101,62.3c0,6.19-2.85,12.22-8,17l0,0c-.07.07-.13.15-.2.23a1.39,1.39,0,0,0-.15.19,1.76,1.76,0,0,0-.14.23,2.53,2.53,0,0,0-.12.23,1.84,1.84,0,0,0-.09.25,1.48,1.48,0,0,0-.11.5c0,.1,0,.2,0,.3a.43.43,0,0,1,0,0v20.37L71,89.1A2.78,2.78,0,0,0,69.43,88.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounselor);
export default __webpack_public_path__ + "static/media/Counselor.22b7d1209954abd7ba3a124717e31f8e.svg";
export { ForwardRef as ReactComponent };